/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamOfTheWeekLineup = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        players: {
            type: 'array',
            contains: {
                type: 'TeamOfTheWeekLineupPositionPlayer',
            },
            isRequired: true,
        },
        isSubcategory: {
            type: 'boolean',
        },
        type: {
            type: 'LineupType',
            isRequired: true,
        },
    },
} as const;
